const Spinner = ({ className = "" }) => (
  <i className={`fas fa-spin fa-spinner ${className}`}></i>
);

export default Spinner;
